import { isAccommodationItem, isExperienceItem } from 'lib/checkout/checkoutUtils'
import { createSelector } from 'reselect'

export const hasBundledAccommodationRate = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items): boolean => {
    const accommItemAndBundleIds = new Set<string>()
    for (const item of items) {
      if (isAccommodationItem(item) && 'accommBundleIds' in item && !!item.accommBundleIds?.length) {
        for (const accommBundleId of item.accommBundleIds) {
          accommItemAndBundleIds.add(`${item.itemId}:${accommBundleId}`)
        }
      }
    }

    if (!accommItemAndBundleIds.size) {
      return false
    }

    return items.some(item =>
      isExperienceItem(item) &&
      'bundledItemIds' in item &&
      !!item.bundledItemIds?.length &&
      !!item.isAccomBundle &&
      item.bundledItemIds.some(accommItemId => accommItemAndBundleIds.has(`${accommItemId}:${item.isAccomBundle}`)),
    )
  },
)
